let allBuyNowBtn = document.querySelectorAll("#xdBannerDropdownOpenId");
allBuyNowBtn.forEach((item) => {
  item.addEventListener("click", (e) => {
    if (window.innerWidth <= 768) {
      window.scrollTo({
        top: 1300,
        behavior: "smooth",
      });
      searchInp.focus();
    } else {
      window.scrollTo({
        top: 830,
        behavior: "smooth",
      });
    }
  });
});
